import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { deliverables, insideItems, volumes } from '../data/content';
export function WhatsInside() {
  return <Section emoji="📦" eyebrow="What's inside" title="What’s inside the GLP-1 Clinical Pathway™?" data-id="element-221" data-mp="kvpvhl5o4a4z">
      <h3 className="text-center font-display text-[19px] font-black leading-snug text-navy sm:text-2xl" data-id="element-222" data-mp="px5ihireoqq0">
        📘 The 6 Clinical Volumes That Turn Uncertainty Into Clinical Mastery
      </h3>

      <ol className="mt-6 space-y-3" data-id="element-223" data-mp="fz96koqn9rqu">
        {volumes.map(volume => <li key={volume.number} className="rounded-2xl border border-navy/8 bg-white p-4 shadow-sm sm:p-5" data-id="element-224" data-mp="27b8d8yh1g9g">
            <div className="flex items-start gap-3" data-id="element-225" data-mp="3od84vx139p7i">
              <span className="flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-xl bg-navy text-white" data-id="element-226" data-mp="3odhsxf2kpmak">
                <span className="text-[8px] font-bold uppercase tracking-widest text-teal-400" data-id="element-227" data-mp="3tdvs07m75lwg">
                  Vol
                </span>
                <span className="font-display text-lg font-black leading-none" data-id="element-228" data-mp="37vmaclpik2k9">
                  {volume.number}
                </span>
              </span>
              <div className="min-w-0" data-id="element-229" data-mp="3ls9izlqtwh60">
                <h4 className="text-[15px] font-extrabold leading-snug text-navy sm:text-base" data-id="element-230" data-mp="3hsr0sxqe6k6v">
                  {volume.title}
                </h4>
                <p className="mt-1 text-[14px] font-semibold leading-snug text-teal-700 sm:text-[15px]" data-id="element-231" data-mp="2u1bvcw3bjmre">
                  {volume.hook}
                </p>
                <p className="mt-1.5 text-[13.5px] leading-snug text-navy/65 sm:text-sm" data-id="element-232" data-mp="32wrspn3a8k1q">
                  {volume.text}
                </p>
              </div>
            </div>
          </li>)}
      </ol>

      <div className="mt-6 rounded-3xl border border-teal-200 bg-teal-50/70 p-5 text-center" data-id="element-233" data-mp="2ae4biirepp5x">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-teal-700" data-id="element-234" data-mp="26d2du6d51l62">
          💡 Bottom line
        </p>
        <p className="mt-2 font-display text-lg font-black leading-snug text-navy sm:text-xl" data-id="element-235" data-mp="9b4wb8ftizf2">
          Every patient. Every stage. Every decision — already mapped for you.
        </p>
        <p className="mt-2 text-[14px] leading-snug text-navy/70 sm:text-[15px]" data-id="element-236" data-mp="j3srjyr5gvbo">
          You don’t need more information. You need a clear clinical pathway you can trust.
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-237" data-mp="3mlkfn2260v4l">
        {insideItems.map(item => <article key={item.title} className="rounded-2xl border border-navy/8 bg-cream p-4 shadow-sm" data-id="element-238" data-mp="3rkx05g5kdq40">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-239" data-mp="5c5jl1nuhyd2">
              {item.emoji}
            </span>
            <h3 className="mt-2 text-[15px] font-extrabold leading-snug text-navy sm:text-base" data-id="element-240" data-mp="1bqmz5v2vc07q">
              {item.title}
            </h3>
            <p className="mt-1.5 text-[13.5px] leading-snug text-navy/65 sm:text-sm" data-id="element-241" data-mp="1gsvtaurh98bf">
              {item.text}
            </p>
          </article>)}
      </div>

      <div className="mt-8 rounded-3xl bg-navy p-5 sm:p-6" data-id="element-242" data-mp="2wb1t8pkojpj7">
        <h3 className="text-center font-display text-xl font-black text-white sm:text-2xl" data-id="element-243" data-mp="2riqw1uhbqhuc">
          📲 What do you get immediately?
        </h3>
        <ul className="mt-5 space-y-3" data-id="element-244" data-mp="2mje816epv4q6">
          {deliverables.map(item => <li key={item.text} className="flex gap-3" data-id="element-245" data-mp="2hlw11lk9ezkt">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-400" aria-hidden="true" data-id="element-246" data-mp="2dj9270p68ee4" />
              <span className="text-[14px] leading-snug text-white/85 sm:text-[15px]" data-id="element-247" data-mp="28kxscpyvm3vw">
                {item.text}
              </span>
            </li>)}
        </ul>
        <p className="mt-5 rounded-2xl bg-teal-500/15 p-4 text-center text-[14px] font-semibold leading-snug text-teal-300 sm:text-base" data-id="element-248" data-mp="6t1h7hgmew1n">
          Any patient that walks into your consultation… the Pathway already has the answer.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-249" data-mp="2vjk9sfb6ea7x">
        <CTAButton label="Give me instant access" sublabel="Download in minutes · Works on any device" data-id="element-250" data-mp="2znjl8jhlmiuf" />
      </div>
    </Section>;
}